// extracted by mini-css-extract-plugin
module.exports = {"Container":"LanguageSetting_Container__3ooeX","Heading":"LanguageSetting_Heading__3OiOQ"};